import gql from 'graphql-tag';

export const mutationViewDokkioUser = gql`
  mutation viewDokkioUser (
    $id: DokkioID!
  ) {
    viewDokkioUser (
      id: $id
    )
  }
`;
export default mutationViewDokkioUser;
